<template>
  <v-container>
    <Title title="Education" subtitle="certifications &amp;" />
    <v-row class="text-center">
      <v-col
        xl="4"
        lg="4"
        md="4"
        sm="6"
        xs="12"
        v-for="cert in certifications"
        :key="cert.title"
      >
        <Feature
          :icon="cert.icon"
          :title="cert.title"
          :body="cert.body"
          :cert="cert.cert"
          :link="cert.link"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Feature from "./Feature";
import Title from "./Title";

export default {
  components: {
    Feature,
    Title
  },
  data() {
    return {
      certifications: [
        {
          icon: "fas fa-graduation-cap",
          title: "Bachelors in Health & Sciences",
          body:
            "Angela Sette recieved her Bachelor's Degree in the Health and Sciences at Thomas Jefferson University."
        },
        {
          icon: "fas fa-tooth",
          title: "Licensed Dental Hygienist",
          body:
            "Angela Sette became a licensed dental hygienist at The Philadelphia Community College."
        },
        {
          icon: "fas fa-brain",
          title: "Brain Health Empowerment Coach Certification",
          body:
            "This certification allows her to coach clients with aspects in life that will help obtain optimal Brain Health, Function, and Potential.",
          cert: "Amen Clinics",
          link: "https://www.amenclinics.com/"
        },
        {
          icon: "fas fa-spa",
          title: "Yoga Certification",
          body:
            "A Yoga Certification allows Angela Sette to teach yoga to individuals of all experience levels.",
          cert: "Yogafit",
          link: "https://www.yogafit.com/"
        },
        {
          icon: "fas fa-file-certificate",
          title: "Barre Certification",
          body:
            "Angela Sette received her certification through Balanced Body University. This certification allows her to teach a dance-based workout incorporating ballet with pilates, in a way that sculpts and defines.",
          cert: "Balanced Body",
          link: "https://pilates.com"
        },
        {
          icon: "fas fa-file-certificate",
          title: "Mat Pilates Certification",
          body:
            "A Mat Pilates Certification allows Angela Sette to teach pilates exercises on the floor using a pilates, or yoga mat.",
          cert: "Balanced Body",
          link: "https://pilates.com"
        },
        {
          icon: "fas fa-file-certificate",
          title: "Reformer Pilates Certification",
          body:
            "A Reformer Pilates Certification allows Angela Sette to teach complex pilates exercises on the pilates reformer.",
          cert: "Balanced Body",
          link: "https://pilates.com"
        },
        {
          icon: "fas fa-file-certificate",
          title: "Zumba Certification",
          body:
            "A Zumba Certification allows Angela Sette to teach zumba to individuals of all experience levels.",
          cert: "Zumba",
          link: "https://www.zumba.com/"
        },
        {
          icon: "fas fa-file-certificate",
          title: "Pilates Chair Certification",
          body:
            "Angela Sette received her certification through Balanced Body University. This certification allows her to teach an ultimate strength-building workout improving balance and control.",
          cert: "Balanced Body",
          link: "https://pilates.com"
        },
        {
          icon: "fas fa-file-certificate",
          title: "Pilates Arc/Barrels Certification",
          body:
            "Angela Sette received her certification through Balanced Body University. This certification allows her to teach exercises that stretch and strengthen the body.",
          cert: "Balanced Body",
          link: "https://pilates.com"
        },
        {
          icon: "fas fa-file-certificate",
          title: "Trapeze Pilates Certification",
          body:
            "Angela Sette received her certification through Balanced Body University. This certification allows her to teach exercise principles to new or injured clients as well as improving overall athletic ability.",
          cert: "Balanced Body",
          link: "https://pilates.com"
        }
      ]
    };
  }
};
</script>
